<template>
  <div class="pdfLayout" id="pdfLayout">
    <div id="pageContainer"></div>
  </div>
</template>

<script>
import "pdfjs-dist/web/pdf_viewer.css";
export default {
  name: "PdfDisplay",
};
</script>

<style scoped>
.pdfLayout {
  margin: 10px 0 10px 0px;
  padding: 0;
  position: relative;
  line-height: initial;
}
#pageContainer {
  max-width: 100%;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding-bottom: 5px;
}
@media (max-width: 600px) {
  #pageContainer {
    border: none;
  }
}
</style>
